// Libraries
import { Flex, Text } from '@chakra-ui/react';
import { createElement } from 'react';
// Components

import { SidebarLinkProps } from './SidebarLink.type';
// Utils
import { iconsMap } from '@config/index';

/**
 * Represents a link in the sidebar.
 * @component
 * @param {SidebarLinkProps} props - The props for the SidebarLink component.
 * @param {string} props.text - The text for the SidebarLink.
 * @param {boolean} props.isActive - Determines if the SidebarLink is active.
 * @param {NavigationIcons} props.icon - The icon component for the SidebarLink.
 * @returns {ReactElement} The SidebarLink component.
 */
export const SidebarLink = ({ text, isActive, icon }: SidebarLinkProps) => {
  const borderRight = isActive ? 'active' : 'none';
  const bg = isActive ? 'sidebarLink.active' : 'transparent';
  return (
    <Flex px={5} py={2.5} bg={bg} borderRight={borderRight} align='center'>
      {createElement(iconsMap[icon], { w: 4, h: 4, mr: 2.5, color: 'base' })}
      <Text fontSize='m' fontWeight='medium'>
        {text}
      </Text>
    </Flex>
  );
};
